document.addEventListener('DOMContentLoaded', () => {
  const bundleSection = document.querySelector('.shopify-section-bundle-product');
  if (bundleSection) {
    if(!bundleSection.querySelector('.bundle-item')) {
      bundleSection.closest('.shopify-section--bundle-product').style.display = 'none';
    }
    new Swiper('.shopify-section-bundle-product .bundle-products', {
      slidesPerView: 4.5,
      spaceBetween: 20,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: false,
      },
      freeMode: true,
      breakpoints: {
        0: {
          slidesPerView: 1.2
        },
        375: {
          slidesPerView: 1.5
        },
        425: {
          slidesPerView: 1.8
        },
        768: {
          slidesPerView: 2.1
        },
        900: {
          slidesPerView: 2.4
        },
        1024: {
          slidesPerView: 2.8
        },
        1100: {
          slidesPerView: 3.2
        },
        1200: {
          slidesPerView: 3.6
        },
        1300: {
          slidesPerView: 4.1
        },
        1366: {
          slidesPerView: 4.5
        }
      }
    });
    const bundleProduct = new BundleProducts();
    let totalPrice = 0;
    let totalCompareAtPrice = 0;
    let selectedCount = 0;
    const symbol = bundleSection.getAttribute('symbol');
    const atcs = bundleSection.querySelectorAll('.bundle-atc');
    const totalPriceLabels = bundleSection.querySelectorAll('.total-price');
    bundleSection.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const bundleItem = checkbox.closest('.bundle-item');
        const priceLabel = bundleItem.querySelector('.bundle-price');
        const comparePriceLabel = bundleItem.querySelector('.bundle-compare-price');
        const price = parseInt(priceLabel.getAttribute('price'));
        const compareAtPrice = parseInt(comparePriceLabel.getAttribute('compare'));
        if (checkbox.checked) {
          totalPrice += isNaN(price) ? 0 : price;
          totalCompareAtPrice += isNaN(compareAtPrice) ? 0 : compareAtPrice;
          selectedCount++;
        } else {
          totalPrice -= isNaN(price) ? 0 : price;
          totalCompareAtPrice -= isNaN(compareAtPrice) ? 0 : compareAtPrice;
          selectedCount--;
        }
        updateGlobalData();
      });
    });
    bundleSection.querySelectorAll('select').forEach(select => {
      select.addEventListener('change', (e) => {
        const selectedOption = select.querySelector(`option:nth-child(${select.selectedIndex + 1})`);
        const bundleItem = select.closest('.bundle-item');
        const image = bundleItem.querySelector('.image img');
        const priceLabel = bundleItem.querySelector('.bundle-price');
        const compareAtPriceLabel = bundleItem.querySelector('.bundle-compare-price');
        const variantId = bundleItem.querySelector('.variant_id');
        const checkbox = bundleItem.querySelector('input[type="checkbox"]')

        const price = parseInt(selectedOption.getAttribute('price'));
        const compareAtPrice = parseInt(selectedOption.getAttribute('compare'));

        const imageSrc = selectedOption.getAttribute('image');
        if (imageSrc) {
          image.src = imageSrc;
        }

        const originalPrice = parseInt(priceLabel.getAttribute('price'));
        const originalCompareAtPrice = parseInt(compareAtPriceLabel.getAttribute('compare'));
        priceLabel.setAttribute('price', price);
        priceLabel.innerHTML = `${symbol}${(price / 100).toFixed(2).replace('.00', '')}`;

        compareAtPriceLabel.setAttribute('compare', isNaN(compareAtPrice) ? '' : compareAtPrice);
        compareAtPriceLabel.innerHTML = `${!isNaN(compareAtPrice) ? symbol + (compareAtPrice / 100).toFixed(2).replaceAll('.00', '') : ''}`;

        variantId.value = selectedOption.getAttribute('variant_id');

        if (checkbox.checked) {
          totalPrice -= isNaN(originalPrice) ? 0 : originalPrice;
          totalCompareAtPrice -= isNaN(originalCompareAtPrice) ? 0 : originalCompareAtPrice;

          totalPrice += isNaN(price) ? 0 : price;
          totalCompareAtPrice += isNaN(compareAtPrice) ? 0 : compareAtPrice;
          updateGlobalData();
        }
      });
    });
    const updateGlobalData = () => {
      atcs.forEach(atc => {
        atc.innerHTML = selectedCount > 0 ? `Add ${selectedCount} item${selectedCount > 1 ? 's' : ''} to cart` : 'Add to Cart';
        selectedCount > 0 ? atc.classList.remove('disabled') : atc.classList.add('disabled');
      })
      totalPriceLabels.forEach(totalPriceLabel => {
        totalPriceLabel.innerHTML = `Total Price: ${symbol}${(totalPrice / 100).toFixed(2).toString().replace('.00', '')} <p class='bundle-compare-price'>${symbol}${(totalCompareAtPrice / 100).toFixed(2).toString().replace('.00', '')}</p>`;
      });
    }
    atcs.forEach(atc => {
      atc.addEventListener('click', () => {
        if (selectedCount > 0) {
          const variantIds = bundleSection.querySelectorAll('.bundle-item:has(input[type="checkbox"]:checked) .variant_id');
          const variants = [];
          variantIds.forEach(variantId => {
            variants.push(variantId.value);
          });
          bundleProduct.setVariants(variants);
          bundleProduct.addProducts().then(res=>{
            console.log(res);
          });
        }
      });
    });
  }
});
class BundleProducts {
  constructor(variants) {
    this.variants = variants instanceof Array ? variants : [];
  }
  addProducts() {
    return new Promise((resolve, reject) => {
      if (this.variants.length > 0) {
        const data = {
          items: this.variants.map(variant=>{
            return {
              id: variant,
              quantity: 1
            };
          })
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(res=>res.json()).then(res=>{
          resolve(res);
        }).catch(err=>{
          reject({error: err});
        });
      } else {
        reject({
          error: 'no variants'
        })
      }
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  renderContents() {
    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) {
        return;
      }
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    }));
  }
  setVariants(variants) {
    this.variants = variants instanceof Array ? variants : [];
  }
}